export default {
      id: "icon-leads-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-leads",
      toString: function () {
        return this.url;
      }
    }